import VideoProfile from "components/VideoProfile";
import React, { Suspense } from "react";
import { TabPanel } from "react-tabs";

const videoList = [
  {
    type: "Location",
    videoTitle: "How to get the best branch Location?",
    viewsText: "30K Views",
    videoTime: "1:05",
    thumbSrc:
      "https://ninja-content.s3.us-east-1.amazonaws.com/thumbnails/location.png",
    videoSrc:
      "https://ninja-content.s3.us-east-1.amazonaws.com/videos/Location_Final.mp4",
  },
  {
    type: "Financial",
    videoTitle: "How to Read a P&L",
    viewsText: "30K Views",
    videoTime: "2:21",
    thumbSrc:
      "https://ninja-content.s3.us-east-1.amazonaws.com/thumbnails/cost.png",
    videoSrc:
      "https://ninja-content.s3.us-east-1.amazonaws.com/videos/Cost+Structure_Final.mp4",
  },
];

export default function VideosSection() {
  return (
    <>
      {/* videos section */}
      <div>
        {[...Array(5)].map((_, index) => (
          <TabPanel
            key={`tab-panel${index}`}
            className="absolute justify-center"
          >
            <div className="w-full">
              <div className="grid grid-cols-8 gap-3 px-[22px] lg:grid-cols-6 md:grid-cols-4 sm:grid-cols-1 sm:px-4">
                <Suspense fallback={<div>Loading feed...</div>}>
                  {videoList.map((d, index) => (
                    <VideoProfile
                      {...d}
                      key={"listuserOne" + index}
                      className="rounded-[12px] bg-black-900_01"
                    />
                  ))}
                </Suspense>
              </div>
            </div>
          </TabPanel>
        ))}
      </div>
    </>
  );
}
